import produce from 'immer';
import {
  SET_EDITABLE_TAX_RATE,

  GET_STORE_TAX_RATES_START,
  GET_STORE_TAX_RATES_SUCCESS,
  GET_STORE_TAX_RATES_FAILED,

  CREATE_NEW_TAX_RATES_START,
  CREATE_NEW_TAX_RATES_SUCCESS,
  CREATE_NEW_TAX_RATES_FAILED,

  EDIT_TAX_RATE_START,
  EDIT_TAX_RATE_SUCCESS,
  EDIT_TAX_RATE_FAILED,

  DELETE_TAX_RATE_START,
  DELETE_TAX_RATE_SUCCESS,
  DELETE_TAX_RATE_FAILED
} from '../actions/tax_rates';

import {
  ADD_USER_STORE_SUCCESS,
} from '../actions/admin';


const initialState = {
  editableTaxRate: {},
  taxRatesList: [],
  taxRule: {},
  loadingTaxRates: false,
  loadingEditTaxRates: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case SET_EDITABLE_TAX_RATE: {
      const { tax } = action;
      state.editableTaxRate = tax;
      break;
    }

    case GET_STORE_TAX_RATES_START: {
      state.loadingTaxRates = true;
      break;
    }

    case GET_STORE_TAX_RATES_SUCCESS: {
      const { taxRates, taxRule } = action;
      state.taxRatesList = taxRates;
      state.taxRule = taxRule;
      state.loadingTaxRates = false;
      break;
    }

    case GET_STORE_TAX_RATES_FAILED: {
      state.loadingTaxRates = false;
      break;
    }

    case CREATE_NEW_TAX_RATES_START: {
      state.loadingTaxRates = true;
      break;
    }

    case CREATE_NEW_TAX_RATES_SUCCESS: {
      const { newTaxRate } = action;
      state.taxRatesList = [...state.taxRatesList, newTaxRate];
      state.loadingTaxRates = false;

      break;
    }

    case CREATE_NEW_TAX_RATES_FAILED: {
      state.loadingTaxRates = false;
      break;
    }

    case EDIT_TAX_RATE_START: {
      state.loadingEditTaxRates = true;
      break;
    }

    case EDIT_TAX_RATE_SUCCESS: {
      const { data } = action;
      const editedTaxRatesList = state.taxRatesList.map((v) => {
        if (v.id === data.id) {
          return data;
        }

        return v;
      });
      state.taxRatesList = [...editedTaxRatesList];
      state.loadingEditTaxRates = false;
      break;
    }

    case EDIT_TAX_RATE_FAILED: {
      state.loadingEditTaxRates = false;
      break;
    }

    case DELETE_TAX_RATE_START: {
      state.deleteTaxRates = true;
      break;
    }

    case DELETE_TAX_RATE_SUCCESS: {
      const { idTaxRate, updatedTaxRule } = action;
      state.deleteTaxRates = false;
      state.taxRatesList = state.taxRatesList.filter((value) => value.id !== idTaxRate);
      state.taxRule = updatedTaxRule;

      break;
    }

    case DELETE_TAX_RATE_FAILED: {
      state.deleteTaxRates = false;
      break;
    }

    case ADD_USER_STORE_SUCCESS: {
      state.taxRatesList = [];
      break;
    }

    default:
      break;
  }
}, initialState);


export default formReducer;
